import { Card, CardContent } from '@components/card';
import { Loader } from '@components/loader';
import { useMerchantForm } from '@hooks/forms/merchants';
import { BaseLayout } from '@layouts/base';
import { Page404 } from '@pages/404';
import { MerchantForm } from '@components/forms/merchants';
import { useGetMerchant } from '@services/acquirer/merchants/get';
import { useUpdateMerchant } from '@services/acquirer/merchants/update';
import { createFileRoute, redirect, useNavigate, useParams } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

const EditMerchant = () => {
  const { t } = useTranslation('app');
  const navigate = useNavigate();
  const { merchantId, localId } = useParams({
    from: '/u/$localId/_acquirer/acquirer/merchants/$merchantId/edit',
  });

  const { data, isPending } = useGetMerchant(merchantId);
  const requestHandler = useUpdateMerchant({
    id: data?.id || '',
    successHandler: (merchant) => {
      toast.success(t('toast.merchants.createSuccess'));
      navigate({
        to: '/u/$localId/acquirer/merchants/$merchantId',
        params: { merchantId: merchant.merchantId, localId },
        replace: true,
      }).catch((err) => {
        console.error(err);
      });
    },
  });

  const form = useMerchantForm({
    merchant: data,
    requestHandler,
  });

  if (isPending) return <Loader />;
  if (!data) return <Page404 />;

  return (
    <BaseLayout isChild title={t('pages.merchants.update')}>
      <Card>
        <CardContent className="p-6">
          <MerchantForm formObj={form} submitText={t('form.submit.merchantUpdate')} />
        </CardContent>
      </Card>
    </BaseLayout>
  );
};

export const Route = createFileRoute('/u/$localId/_acquirer/acquirer/merchants/$merchantId/edit')({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['merchants_update'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: EditMerchant,
});
